<script>
import request from '@/services/request'
import { mapActions } from 'vuex';
import ModalContractEndsComponent from './ModalContractEndsComponent.vue';
import ModalUserDepartamentComponent from '../departments/ModalUserDepartamentComponent.vue';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        ModalContractEndsComponent,
        ModalUserDepartamentComponent
    },
    data() {
        return {
            editForm: false,
            tenants: [],
        }
    },
    methods: {
        editBuy(buy = {}, edit = true) {
            this.editForm = edit;
            Event.$emit('event-show-addDepartamentUserRelation', buy);
        },
        deleted: function (id) {
            let tit = 'Eliminar contrato';
            let txt = 'Seguro que quiere eliminar el contrato';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.callDeleted(id);
                }
            });
        },
        async callDeleted(id) {
            let _endpoint = '/tenant/' + id;
            try {
                let response = await request.destroy(_endpoint).then(function (response) { return response; });
                this.list();
                this.successNotification(response.data.message);
            } catch (error) {
                this.errors = await this.errorNotification(error)
            }
        },
        downloadRecibe(id) {
            window.open(this.globalUrlFiles + '/contracts/pdf/' + id, '_blank');
        },
        changeStatus: function (buy) {
            Event.$emit('event-show-changeStatusContractsRelation', buy);
        },
        closedModal() {
            this.$modal.hide('ListTenantsRelation');
        },
        async list(page = 1) {
            this.load = true;
            let service = request;
            let search = {
                department_id: this.department_id,
                search: '',
                building_id: '',
                company_id: '',
                user_id: '',
                status: 1,
                finish: '',
                payment_period_id: [1, 2, 3, 4, 6, 7, 8, 9]
            };

            let _endpoint = '/tenant';
            try {
                let { data } = await service.list(_endpoint, page, search)
                if (data) {
                    console.log(data);
                    this.tenant = data;
                    this.load = false;
                }
            } catch (error) {
                console.log(error);
            }
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-ContractsRelation", (tenants) => {
            this.tenants = tenants;
            this.$modal.show('ListTenantsRelation');
        });
    }
}
</script>
<template>
    <modal name="ListTenantsRelation" :width="'80%'" :scrollable="true" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Contratos Relacionados</h5>
        </div>
        <div class="modal-body">
            <ModalContractEndsComponent :prop_edit="false" />
            <ModalUserDepartamentComponent :prop_edit="this.editForm" />
            <div class="row">
                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table table-bordered text-center text-sm">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th style="width: 50%;">Datos del pago</th>
                                    <th>Fecha</th>
                                    <th style="width: 140px;">Monto</th>
                                    <th style="width: 140px;">Deposito de garantía</th>
                                    <th>Opciones</th>
                                </tr>
                            </thead>
                            <tbody v-if="tenants.length > 0">
                                <tr v-for="(tenant, index) in tenants" :key="index">
                                    <td>
                                        {{ tenant.id }}
                                        <i v-if="tenant.signed_contract == ''"
                                            class="fa-solid fa-file-pen text-warning fa-xl fa-fade mt-4"></i>
                                    </td>
                                    <td class="text-left">
                                        <h5 v-if="tenant.is_current">
                                            <span class="badge badge-success">Al corriente</span>
                                        </h5>

                                        <strong>Propiedad:</strong>
                                        <span v-if="tenant.building">
                                            {{ tenant.building.name }}
                                        </span>
                                        <span v-else>Sin propiedad</span>
                                        <br>

                                        <strong>Indiviso:</strong>
                                        <span v-if="tenant.department">
                                            {{ tenant.department.level }} / {{ tenant.department.number }}
                                        </span>
                                        <span v-else>Sin indiviso</span>
                                        <br>

                                        <strong>Usuario:</strong>
                                        <span v-if="tenant.user">
                                            {{ tenant.user.name }} {{ tenant.user.last_name }}
                                        </span>
                                        <span v-else>Sin usuario</span>
                                        <br>

                                        <!-- Recurrencia -->
                                        <strong>Recurrencia:</strong>
                                        <span v-if="tenant.payment_period"> {{ tenant.payment_period.name
                                            }}</span>
                                        <span v-else>Sin Recurrencia</span>
                                        <br>

                                        <strong>Fecha de captura:</strong>
                                        <span>
                                            {{ tenant.created_at | toDateTime }}
                                        </span>
                                        <br>



                                        <hr>
                                        <strong>Servicios:</strong>
                                        <span v-if="tenant.services.length > 0">
                                            <span class="badge badge-primary p-1 m-1"
                                                v-for="(serv, index_serv) in tenant.services" :key="index_serv">
                                                {{ serv.name }}
                                            </span>
                                        </span>
                                        <span v-else>S/N</span>

                                        <br v-if="tenant.user_reviewed">
                                        <span v-if="tenant.user_reviewed">
                                            <b>Autorizado por:</b>
                                            <span class="badge badge-warning">
                                                {{ tenant.user_reviewed.name }} {{ tenant.user_reviewed.last_name }}
                                            </span>
                                        </span>

                                        <br v-if="tenant.user_juridico">
                                        <span v-if="tenant.user_juridico">
                                            <b>Jurídico Autorizo:</b>
                                            <span class="badge badge-primary">
                                                {{ tenant.user_juridico.name }} {{ tenant.user_juridico.last_name }}
                                            </span>
                                        </span>

                                        <br v-if="tenant.user_countable">
                                        <span v-if="tenant.user_countable">
                                            <b>Analista Autorizo:</b>
                                            <span class="badge badge-primary">
                                                {{ tenant.user_countable.name }} {{ tenant.user_countable.last_name }}
                                            </span>
                                        </span>

                                        <br v-if="tenant.user_created">
                                        <span v-if="tenant.user_created">
                                            <b>Creado por:</b>
                                            <span class="badge badge-secondary">
                                                {{ tenant.user_created.name }} {{ tenant.user_created.last_name }}
                                            </span>
                                        </span>

                                        <hr>

                                        <button type="button" v-if="tenant.deposit > 0"
                                            @click="downloadRecibe(tenant.id)"
                                            class="btn m-1 btn-outline-secondary btn btn-sm ">
                                            <i class="fa-solid fa-file-pdf"></i> Recibo depósito de garantía
                                        </button>

                                        <button type="button" @click="changeStatus(tenant)" v-can="'deleted_contracts'"
                                            :class="tenant.status == 1 ? 'btn-outline-danger' : 'btn-outline-success'"
                                            class=" btn m-1 btn-sm ">
                                            <span v-if="tenant.status == 1">
                                                <i class="fa-solid fa-power-off"></i> Terminar
                                            </span>
                                            <span v-else>
                                                <i class="fa-solid fa-power-off"></i> Activar
                                            </span>
                                        </button>

                                        <button @click="createFrom(tenant)" type="button" v-if="tenant.status == 2"
                                            class="btn btn-sm  m-1 btn-outline-secondary ">
                                            <i class="fa-solid fa-file-circle-plus"></i> Generar contrato
                                        </button>

                                        <button type="button" @click="deleted(tenant.id)" v-can="'deleted_contracts'"
                                            class="btn-outline-danger btn m-1 btn-sm ">
                                            <i class="fa fa-trash"></i> Eliminar
                                        </button>
                                    </td>
                                    <td>
                                        <span v-if="tenant.star_date"> {{ tenant.star_date | toDateTime }} </span>
                                        <span v-if="tenant.end_date"> - {{ tenant.end_date | toDateTime }} </span>

                                    </td>
                                    <td class="text-right">
                                        {{ tenant.amount | toCurrency }}
                                    </td>
                                    <td class="text-right">
                                        {{ tenant.deposit | toCurrency }}
                                    </td>
                                     <td>        

                                    <button @click="editBuy(tenant, false)" type="button"
                                        class="btn btn-sm  m-1 btn-outline-secondary ">
                                        <i class="fa-solid fa-eye"></i> Ver
                                    </button>

                                    <button @click="editBuy(tenant)" v-can="'edit_contracts'"
                                        class="btn btn-outline-primary m-1 btn-sm">
                                        <i class="fas fa-edit "> </i> Editar
                                    </button>

                                 
                                </td>


                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td align="center" colspan="6">Sin pagos.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>